import React from 'react';
import Modal from '@web-common/components/UI/SiriusModal';
import style from './CheckboxModal.module.scss';
import classnames from 'classnames/bind';
import Button from '@web-common/components/UI/Button';
import { Checkbox } from '@web-common/components/UI/Checkbox';
import { ReactComponent as InfoIcon } from '@/images/icons/mail/info_blue_icon.svg';
import { getIn18Text } from 'api';
const realStyle = classnames.bind(style);
const CheckboxConfirmContent = (props) => {
    const { onOk, onCancel, checked, onChange } = props;
    return (React.createElement("div", { className: "checkbox-confirm-footer" },
        React.createElement("div", { className: "left" },
            React.createElement(Checkbox, { onChange: onChange, value: checked }, getIn18Text('BUZAITIXING'))),
        React.createElement("div", { className: "right" },
            React.createElement(Button, { className: "cancel", onClick: onCancel, btnType: "minorLine", size: "mini", inline: true }, getIn18Text('QUXIAO')),
            React.createElement(Button, { className: "cancel", onClick: onOk, btnType: "primary", size: "mini", inline: true }, getIn18Text('QUEDING')))));
};
export const checkboxConfirm = config => {
    const { okText = getIn18Text('QUEDING'), cancelText = getIn18Text('QUXIAO'), checkBoxText = getIn18Text('BUZAITIXING'), autoFocusButton, onOk, onCancel, checked, onChange, title, showCheck = true, icon = React.createElement(InfoIcon, null), } = config;
    let local_checked = checked || false;
    return Modal.info(Object.assign({ modalRender: modal => {
            return (React.createElement("div", { className: realStyle('checkboxModalWrap') },
                React.createElement("div", { className: realStyle('titleWrap') },
                    React.createElement("div", { className: realStyle('icon') }, icon),
                    React.createElement("div", { className: realStyle('title') }, title)),
                React.createElement("div", { className: realStyle('checkboxConfirmFooter') },
                    React.createElement("div", { className: realStyle('left'), style: { pointerEvents: 'auto' } }, showCheck ? (React.createElement(Checkbox, { className: realStyle('checkbox'), value: local_checked, onChange: value => {
                            local_checked = value;
                        } }, checkBoxText)) : (React.createElement(React.Fragment, null))),
                    React.createElement("div", { className: realStyle('right'), style: { pointerEvents: 'auto' } },
                        React.createElement(Button, { className: realStyle('cancel'), onClick: onCancel, btnType: "minorLine", inline: true }, cancelText),
                        React.createElement(Button, { autoFocus: true, className: realStyle('ok'), onClick: () => onOk(local_checked), btnType: "primary", inline: true }, okText)))));
        } }, config));
};
export default CheckboxConfirmContent;
